/**
 * Authentication State Management
 * Using Recoil for state management
 */

import { atom } from 'recoil';

export interface UserInfo {
  id: string;
  email: string;
  name: string;
  tenantId: string;
}

export interface GuardState {
  header: string | null;
  exp: number | null;
}

export const tokenState = atom<string | null>({
  key: 'tokenState',
  default: null,
});

export const userInfoState = atom<UserInfo | null>({
  key: 'userInfoState',
  default: null,
});

export const isAuthenticatedState = atom<boolean>({
  key: 'isAuthenticatedState',
  default: false,
});

export const guardState = atom<GuardState>({
  key: 'guardState',
  default: { header: null, exp: null },
});
